import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TreatmentTypeFile } from '../models';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments';

const basePath = `${environment.apiBaseUrl}treatment-type-file`;

@Injectable({ providedIn: 'root' })
export class TreatmentTypeFileApiClient {
    private readonly _http = inject(HttpClient);

    get(typeId: number): Observable<TreatmentTypeFile[]> {
        return this._http.get<TreatmentTypeFile[]>(`${basePath}/${typeId}/messenger`);
    }

    getByTypeOriginals(typeId: number): Observable<TreatmentTypeFile[]> {
        return this._http.get<TreatmentTypeFile[]>(`${basePath}/${typeId}/originals`);
    }

    getByTypeDesigns(typeId: number): Observable<TreatmentTypeFile[]> {
        return this._http.get<TreatmentTypeFile[]>(`${basePath}/${typeId}/designs`);
    }
}
